import { createAsyncThunk } from "@reduxjs/toolkit";
import { Auth } from "../libs/utilities/helpers/Auth";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_MARKETING;


export const getTargetGroups = createAsyncThunk(
    "/marketing/target/groups",
    async (_, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.get("/marketing/target/groups", {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// fetch the dropdown
export const getDropDownList = createAsyncThunk(
    "/marketing/dropdown/get",
    async (data, { rejectWithValue }) => {
        try {
            // const user = Auth.getUser();
            setBaseURL(api, DEV_BASE_URL)
            const response = await api.post("/marketing/dropdown/get", data, {
                headers: {
                    "Content-Type":'application/json'
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const getPromptResponse = createAsyncThunk(
    "/marketing/generate",
    async (data, { rejectWithValue }) => {
        try {
            // const user = Auth.getUser();
            setBaseURL(api, DEV_BASE_URL)
            const response = await api.post("/marketing/generate", data, {
                headers: {
                    "Content-Type":'application/json'
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)
export const addNewFieldInDB = createAsyncThunk(
    "/marketing/dropdown/update",
    async (data, { rejectWithValue }) => {
        try {
            // const user = Auth.getUser();
            setBaseURL(api, DEV_BASE_URL)
            const response = await api.post("/marketing/dropdown/update", data, {
                headers: {
                    "Content-Type":'application/json'
                },
            });
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)
export const getEmailPromptResponse = createAsyncThunk(
    "/generate_message",
    async (data, { rejectWithValue }) => {
        try {
            // const user = Auth.getUser();
            setBaseURL(api, DEV_BASE_URL)
            const response = await api.post("/marketing/generate_email", data, {
                headers: {
                    "Content-Type":'application/json'
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const getCustomPromptResponse = createAsyncThunk(
    "/marketing/custom/prompt",
    async (data, { rejectWithValue }) => {
        try {
            // const user = Auth.getUser();
            setBaseURL(api, DEV_BASE_URL)
            const response = await api.post("/marketing/custom/prompt", data, {
                headers: {
                    "Content-Type":'application/json'
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)
export const getCTAResponse = createAsyncThunk(
    "/marketing/generate",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL)
            const response = await api.post("/marketing/generate", data, {
                headers: {
                    "Content-Type":'application/json'
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)